'use strict';

// The forced password change after sign-in (ST4S A2, R4; Elm: Page.ForcePasswordChange).
//
// - A per-user flag in localStorage keeps a teacher on the "Set a new password" page across a
//   reload (handleRefreshIfAlreadyAuthenticated reports it to Elm) until the change succeeds.
// - changePassword: client-side HIBP check, then ChangePasswordCommand with the signed-in
//   user's access token. Never logs a password.

import { Auth } from '@aws-amplify/auth';
import { CognitoService } from '../services/CognitoService';
import { isPasswordBreached, BREACHED_PASSWORD_MESSAGE } from './breachCheck';

const FLAG_PREFIX = 'smPasswordChangeRequired.';

export const setPasswordChangeRequired = ({ username, required }) => {
    try {
        if (required) {
            localStorage.setItem(FLAG_PREFIX + username, '1');
        } else {
            localStorage.removeItem(FLAG_PREFIX + username);
        }
    } catch (e) {
        // storage unavailable: the policy check at the next sign-in still applies
    }
};

export const isPasswordChangeRequired = (username) => {
    try {
        return localStorage.getItem(FLAG_PREFIX + username) === '1';
    } catch (e) {
        return false;
    }
};

const currentAccessToken = async () => {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
};

// Resolves { ok: true } or { ok: false, message } (the message is shown to the user).
export const changePassword = async ({ previousPassword, proposedPassword }) => {
    if (await isPasswordBreached(proposedPassword)) {
        return { ok: false, message: BREACHED_PASSWORD_MESSAGE };
    }
    try {
        const accessToken = await currentAccessToken();
        await new CognitoService().changePassword(accessToken, previousPassword, proposedPassword);
        return { ok: true };
    } catch (error) {
        if (ISDEBUG) { console.log('changePassword failed:', error && error.code); }
        return { ok: false, message: (error && error.message) || 'Sorry, we could not change your password. Please try again.' };
    }
};
